
import './App.css';


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import RegistrationForm from './components/form';

import ThanksPage from './components/thanks_page';


const winners = [
  { name: null, points: 100 },
  { name: null, points: 90 }
];

function App() {
  return (
    <Router>
        <Routes>
            <Route path="/" element={<Header winners={winners} />} />
            <Route path="/register" element={<RegistrationForm />} />
            <Route path="/thanks" element={<ThanksPage />} /> 
        </Routes>
    </Router>
);
}

export default App;
